module.exports = __webpack_public_path__ + "img/question-circle-fill.ee628e65.svg";